"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var paymentDisclaimerModalStyles_1 = require("./paymentDisclaimerModalStyles");
var ModalWithHeader_1 = require("../../../../../common/components/presentation/ModalWithHeader/ModalWithHeader");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var react_intl_1 = require("react-intl");
var PaymentDisclaimerModal = function (_a) {
    var isOpen = _a.isOpen, toggleModal = _a.toggleModal;
    var styles = paymentDisclaimerModalStyles_1.default();
    var intl = react_intl_1.useIntl();
    return (<ModalWithHeader_1.default open={isOpen} toggleModal={toggleModal} title={<Translation_1.default id="trans__checkout__enquiry_form__reserve_online_terms_and_conditions_title_page"/>}>
      <core_1.Typography data-test={"payment_disclaimer_modal"} className={styles.root} dangerouslySetInnerHTML={{
        __html: intl.formatMessage({
            id: 'trans__checkout__next_step__payment_page_disclaimer__terms_and_condition_modal',
        }),
    }}/>
    </ModalWithHeader_1.default>);
};
exports.default = PaymentDisclaimerModal;
